import React, { useContext } from 'react';
import './userTutorialDetailPane.module.scss';
import ImageShechan from './images/she_chan_comment.svg';
import ImageDoneStamp from './images/done_stamp.svg';
import { UserTutorialDetailAction } from '../../atoms/user_tutorial/UserTutorialDetailAction';
import { BackButton } from '../../../../commonv3/components/atoms/buttons/BackButton';
import { UserTutorialDetailSource } from '../../atoms/user_tutorial/UserTutorialDetailSourses';
import { UserTutorialCompletionKey } from '../../../types/userTutorialCompletions';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import { UserTutorialCompletionContext } from '../../../contexts/userTutorialCompletion';
import { userTutorialDetailTexts } from '../../atoms/user_tutorial/UserTutorialDetailTexts';
import { LoaderRow } from '../../atoms/layout/LoaderRow';

type Props = {
    match: {
        params: {
            page_key: UserTutorialCompletionKey;
        };
    };
};

export const UserTutorialDetailPane = ({
    match: {
        params: { page_key },
    },
}: Props) => {
    const context = useContext(UserTutorialCompletionContext);
    const { resource } = context;
    const { hasCompleted, submitting } = resource;
    const { number, title, description, comment } = userTutorialDetailTexts(page_key);
    const hasCompletedTheTutorial = hasCompleted(page_key);
    if (resource.loading) {
        return <LoaderRow />;
    }
    return (
        <div>
            {GlobalStatesV3.viewport.isMobile && <BackButton />}
            {hasCompletedTheTutorial ? (
                <img id="completed-tutorial" src={ImageDoneStamp} styleName="stamp" />
            ) : (
                <div id="uncompleted-tutorial" styleName="uncompleted-stamp stamp">
                    未完了
                </div>
            )}
            <div id="user_tutorial-detail-pane" styleName="pane">
                <div styleName="pane-header">
                    <div styleName="tutorial-number">{number}</div>
                    <div styleName="header-title">{title}</div>
                    <div styleName="header-border" />
                </div>
                <div styleName="pane-body">
                    <pre styleName="body-text">{description}</pre>
                </div>
                <div styleName="pane-body">
                    <div styleName="source">
                        <UserTutorialDetailSource page_key={page_key} />
                    </div>
                </div>
                <div styleName="pane-shechan">
                    <div styleName="shechan-icon">
                        <img src={ImageShechan} styleName="" />
                    </div>
                    <pre styleName="shechan-comment">{comment}</pre>
                </div>
                <UserTutorialDetailAction
                    page_key={page_key}
                    hasCompleted={hasCompletedTheTutorial}
                    createCompletion={() => resource.createCompletion(page_key)}
                    loading={submitting}
                />
            </div>
        </div>
    );
};
